<template>
  <div>
    <div>
      <div>
        <v-container class="px-6" fluid>
          <v-row>
              <v-col cols="12">
                  <v-card
                      flat
                      class="neu-glow"
                      color="orange"
                  >
                    <v-card-title class="text-h4">Messaggi</v-card-title>
                    <v-expansion-panels v-if="messages&&messages.length">
                        <v-expansion-panel
                            class="slow"
                            v-for="(item,i) in messages"
                            :key="i"
                        >
                        <v-expansion-panel-header>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn :href="'tel:'+item.phone" icon v-bind="attrs" v-on="on" style="max-width:60px" :disabled="!item.recall">
                                        <v-icon large color="green">mdi-phone-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{!item.recall?'Non c':'C'}}hiede di essere richiamato</span>
                            </v-tooltip>                                
                            <div  :class="item.read?'text-subtitle-1':'text-subtitle-1 font-weight-bold'">
                                {{item.time}}  - {{ item.fullname}}: {{item.subject}} - tel: {{item.phone}}
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row>
                                <v-col cols="12" class="green lighten-4 pl-10">
                                    {{item.message}}
                                </v-col>
                            </v-row>
                            <v-divider class="my-3"></v-divider>
                            <v-row>
                              <v-col>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn :href="'tel:'+item.phone" icon v-bind="attrs" v-on="on">
                                            <v-icon large color="green">mdi-phone</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Chiama</span>
                                </v-tooltip>
                              </v-col>  
                              <v-spacer></v-spacer>                              
                              <v-col class="text-right">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn @click="deleteMessage(item)" icon v-bind="attrs" v-on="on">
                                            <v-icon large  color="red">mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Elimina</span>
                                </v-tooltip> 
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn @click="markRead(item)" icon v-bind="attrs" v-on="on" class="ml-10">
                                            <v-icon large  :color="item.read?'grey':'warning'">mdi-eye-check</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{item.read?'Già letto':'Segna come già letto'}}</span>
                                </v-tooltip>                                      
                              </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <v-card v-else class="py-16 text-center">
                      <v-div class="text-h5 mt-12">Nessun Messaggio</v-div>
                    </v-card>
                  </v-card>
              </v-col>                      
          </v-row>
        </v-container>
      </div>
    </div>

    <v-dialog v-model="dialog_accomplished"
      width="450"
    >
    <v-card>
      <v-card-title class="success text-h4 font-weight-bold">
        Operazione Eseguita
      </v-card-title>
      <v-card-text class="text-h6 success white--text pt-5" v-if="dialog_accomplished_message" v-html="dialog_accomplished_message">
      </v-card-text>
      <v-card-actions class="success">
        <v-spacer></v-spacer>
        <v-btn
          color="warning"
          @click="dialog_accomplished = false"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      page: "Booking",
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_accomplished:false,
      dialog_accomplished_message:'',
      messages:null,
      loading:false,             
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  created(){
    this.getData()
    //console.log(716,this.user);
    /*
    if (this.user&&this.user.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData()
    }*/
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    },
    assignedTable(newValue)
    {
      console.log(794,newValue)
      //this.assignedTables.push(newValue);
      console.log(796,newValue,this.assignedTables)
      this.assignTables(newValue);
    }
  },
  methods:
  {
    async getData()
    {
        {
            this.loading=true;
            try{
                const payload=JSON.stringify({"date": this.date,"action":"getMessages"});
                const res = await this.$http.post('/messages/messages.php', payload );
                console.log(151,res);
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.messages=res.data.messages;
                    console.log(157,this.messages);
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async deleteMessage(item)
    {
        this.snackbar_confirm_cancellation = true
        console.log(1006,item);
        let payload={"action":"deleteMessage","payload":JSON.stringify(item)};
        console.log(1008,payload)
        let w= await this.updateDB(payload)
        console.log(1010,w);       
        this.snackbar=false;
        if (w.errorid=='0')
        {
            this.dialog_deleted=true;
            //this.dialog_accomplished_message=w.message;
            //this.dialog_accomplished = true;
            this.$store.dispatch("setMessagesCount",w.messagesCount);
            const idx=this.messages.findIndex(m =>m.messageId==w.messageId)
            console.log(186,idx)
            this.messages.splice(idx, 1)
            console.log(this.messages);
        }	
    },
    async markRead (item)
    {
        let payload={"action":"markRead","payload":JSON.stringify(item)};
        console.log(1008,payload)
        let w= await this.updateDB(payload)
        console.log(1010,w);       
        this.snackbar=false;
        if (w.errorid=='0')
        {
            this.dialog_deleted=true;
            //this.dialog_accomplished_message=w.message;
            //this.dialog_accomplished = true;
            this.$store.dispatch("setMessagesCount",w.messagesCount);
            const idx=this.messages.findIndex(m =>m.messageId==w.messageId)
            console.log(186,idx)
            this.messages[idx].read=new Date;
            this.messages.sort((a,b) => a.read - b.read)
        }	
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/messages/messages.php', payload);
            console.log(1022,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(1031);
                this.snackbar=true;
            }
            }
            else
            {
            this.snackbar_color='error'
            this.snackbar_message=res.data.message;
            this.snackbar=true;
            console.log(1040);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },
  },
};
</script>
<style scoped>
.slow {
  transition: all 1s ease;
  -webkit-transition: all 1s ease;
}
</style>